interface AvatarVisibleCountOptions {
    itemCount: number;
    max: number;
    /** Unlisted items; when above 0 the chip shows anyway. @default 0 */
    extraCount?: number;
}

/**
 * How many of `itemCount` items a stack shows before its +N chip. A "+1" chip
 * is as wide as the item it hides, so one extra item shows instead, unless
 * unlisted items bring a chip anyway.
 */
export const getAvatarVisibleCount = ({
    itemCount,
    max,
    extraCount = 0,
}: AvatarVisibleCountOptions) =>
    itemCount === max + 1 && extraCount === 0 ? itemCount : max;
